import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M30 15c0 8.284-6.716 15-15 15S0 23.284 0 15 6.716 0 15 0s15 6.716 15 15" }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M20.95 9.75a5.7 5.7 0 1 1-11.4 0 5.7 5.7 0 0 1 11.4 0m-5.7 3.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M15.25 15.975c-3.964 0-7.275 3.426-7.275 7.775a.975.975 0 1 1-1.95 0c0-5.316 4.077-9.725 9.225-9.725s9.225 4.409 9.225 9.725a.975.975 0 1 1-1.95 0c0-4.349-3.31-7.775-7.275-7.775",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }